const ViewMode = {
    Room: 'ROOM',
    ScreenShare: 'SCREENSHARE',
};
export default ViewMode;
